/**
 * Domain-based premium access override
 * CiteOps.ai Dashboard (frontend)
 *
 * Users with emails from specified domains automatically receive Team-tier
 * access regardless of their Stripe subscription status.
 *
 * Keep in sync with: supabase/functions/_shared/domain-override.ts
 */

/** Email domains that receive automatic Team-tier access */
const PREMIUM_DOMAINS: readonly string[] = [
  'coinis.com',
  'coinisconnect.com',
]

/** The tier granted to domain-override users */
export const OVERRIDE_TIER = 'team' as const

/**
 * Check whether an email address belongs to a premium-override domain.
 * Returns true for @coinis.com and @coinisconnect.com addresses.
 */
export function isPremiumDomain(email: string | null | undefined): boolean {
  if (!email || typeof email !== 'string') return false
  const domain = email.toLowerCase().split('@')[1]
  if (!domain) return false
  return PREMIUM_DOMAINS.includes(domain)
}
